<template>
<div class="outer-container d-none d-lg-block">
  <div class="side-menu">

    <div class="action-card">
      <h2>Done Editing?</h2>
      <hr/>
      <p>{{actionParams.help}}</p>
      <hr/>
      <button :class="buttonClass" @click.once="$emit('action')">
        {{actionParams.button}} <i class="fa fa-arrow-right"></i>
      </button>
    </div>

    <WarningBox v-if="canvasState.hasBadBleed && canvasState.displayBleed && !canvasState.dismissedBleedWarning" title="Check Document Bleed">
      <p>Be sure that images and solid colors extend beyond the final size of the card by 1/8" on every side. The file dimensions should be 3.75" x 2.25".

      <p class="mt-3">Look for the bleed warning indicators (<span class="bleed-point ml-1"></span> <span class="bleed-point"></span> <span class="bleed-point mr-1"></span>) in your document.</p>
      <div class="text-center">
        <b-btn class="mt-2 " @click="bus.$emit('dismissBleedWarning');">Looks OK</b-btn>
      </div>

    </WarningBox>

    <WarningBox v-if="!canvasState.hasTextAtStartup" title="Check Document Text">
      <p>Your document has no text.</p>
      <p class="mt-3">Did you convert to curves? Consider uploading a new file that has text objects.</p>
    </WarningBox>

    <div v-else-if="!lockButtons" class="action-card">
      <h2>Add images?</h2>
      <hr/>
      <div @click="bus.$emit('showUploadDialog')" class="uploadArea">
        <span><i class="fas fa-upload"/> Drag File</span>
      </div>
    </div>

    <div class="action-card">
      <h2>Need Help?</h2>
      <hr/>
      <p>Can’t get everything to look as you want?</p>
      <ul class="help-links">
         <li>

           <!-- <a href="#" target="_blank"> -->
          Read <a href="/support/artwork" target="_blank">Artwork Prep FAQs</a>
        </li>
        <li>
          Read <a href="/support/fileupload" target="_blank">Upload FAQs</a>
        </li>
        <li>Feel free to
          <a href="mailto:support@brandly.com" target="_blank">Email us</a>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

  .side-menu {
    margin-top: 117px;
  }
  :host {
    position: absolute;
  }
  .outer-container {
    height: 100vh;
  }
  .uploadArea {
    border: 4px dashed $gray-0;
    background: white;
    height: 3em;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em 2em;
  }

  .bleed-point{
    display:inline-block;
    width:4px;
    height:4px;
    pointer-events:none;
    background-color : magenta;
    border : 1px solid darkblue;
  }

  .wide-button {
    width: 100%;
  }
</style>
<script>
import {mapGetters} from 'vuex';
import WarningBox from './WarningBox'
export default {
  components: {WarningBox},
  props: ['actionParams', 'canvasState', 'bus'],
  computed: {
    ...mapGetters(['isTemplate', 'flags', 'designOptions']),
    designLocked() {
      if (!this.designOptions) return false;
      return this.designOptions.lockDesign;
    },
    lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    buttonClass() {
      if (this.actionParams.variant == 'action') {
        // the btn-action overrides the bootstrap styles,
        // and needs to NOT include btn. As a consequence, it's also square.
        // TODO make it look right with "btn"
        return 'btn-action sidebar-purchase-link';
      } else {
        return `btn btn-${this.actionParams.variant} wide-button`;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/SideMenu.vue